import Link from "./universalComponents/Link";

const Footer = (props) => {
    return (
        <footer>
            <Link link="https://github.com/Essoh21/cv-project"
                linkText="Copyright@Essohanam" />
        </footer>
    )
}

export default Footer;